import Loader from './Loader.component';

export default Loader;
